import React from 'react'
import { Navigate } from 'react-router'

import { useOnboardingGuard } from './hooks/use-onboarding-guard'

import { paths } from '@/config/path'

export const OnboardingGuard = React.memo(({ children }: { children: React.ReactNode }) => {
  const { needsOnboarding, isTechnician } = useOnboardingGuard()

  if (isTechnician && needsOnboarding) {
    return <Navigate to={paths.onboarding.getHref()} />
  }

  return <>{children}</>
})

OnboardingGuard.displayName = 'OnboardingGuard'
